// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__pHmdE","title":"Header_title__3u6Hp","side":"Header_side__bvBAE"};